import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";
import PinitComponent from "../pinitComponent";

export class BlogGallerySwiper {
  private readonly swiperDiv: HTMLDivElement;
  private readonly swiper: Swiper;

  constructor(swiperDiv: HTMLDivElement) {
    this.swiperDiv = swiperDiv;
    this.swiper = new Swiper(this.swiperDiv, params);
    this.swiper.loaded = true;
  }
}

const params = {
  lazy: {
    loadPrevNext: true,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    slideChange,
    lazyImageReady(slide, image) {
      PinitComponent.pinit(image, {
        minHeight: 5,
        minWidth: 5,
      });
    },
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination-gallery",
    type: "bullets",
  },
  preloadImages: false,
  simulateTouch: false,
  spaceBetween: 10,
};

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("BlogGallerySwiper.Swiped");
  }
}
